import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import './modal.scss';
import classNames from 'classnames';

const Modal = ({
  isVisible,
  onHide,
  children,
  className,
}) => {
  const rootRef = useRef(document.createElement('div'));
  useEffect(() => {
    const root = rootRef.current;
    root.className = 'modal-root';
    if (!isVisible) {
      if (document.body.contains(root)) {
        document.body.removeChild(root);
      }
    } else {
      document.body.append(root);
    }

    return () => {
      if (document.body.contains(root)) {
        document.body.removeChild(root);
      }
    };
  }, [isVisible]);

  const modalBody = (
    <div className={classNames('modal-window', 'modal-root__window', className)}>
      <div className="modal-window__header">
        <button className="modal-window__close-button" onClick={onHide}>
          ×
        </button>
      </div>
      <div className="modal-window__content">
        {children}
      </div>
    </div>
  );

  return isVisible ? createPortal(modalBody, rootRef.current) : null;
};

export default Modal;
